import { render, staticRenderFns } from "./GroupByOrder.vue?vue&type=template&id=afc3b532&scoped=true&"
import script from "./GroupByOrder.vue?vue&type=script&lang=js&"
export * from "./GroupByOrder.vue?vue&type=script&lang=js&"
import style0 from "./GroupByOrder.vue?vue&type=style&index=0&id=afc3b532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc3b532",
  null
  
)

export default component.exports